import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAppSelector } from "Redux/hooks";

import TopNav from "Containers/TopNavbar";
import Sidebar from "Containers/Offcanvas";

import MainSection from "./main";
import ShortcodesSection from "./shortcodes";
import ChartsSection from "./charts";
import ExtrasSection from "./extras";
import BlankSection from "./blank";
import MailsSection from "./mails";
import EditorSection from "./editor";

export default function MainLayout() {
  const containerClassnames = useAppSelector(s => s.menu.containerClassnames);

  return (
    <div id="app-container" className={containerClassnames}>
      <TopNav />
      <Sidebar />
      <main>
        <div className="container-fluid">
          <Routes>
            <Route path="main/*" element={<MainSection />} />
            <Route path="shortcodes/*" element={<ShortcodesSection />} />
            <Route path="charts/*" element={<ChartsSection />} />
            <Route path="extras/*" element={<ExtrasSection />} />
            <Route path="blank/*" element={<BlankSection />} />
            <Route path="mails/*" element={<MailsSection />} />
            <Route path="editor/*" element={<EditorSection />} />
            <Route path="*" element={<Navigate to="/error" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
